import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const ExternalProvidersPage = lazy(() => import('@pages/externalProviders/ExternalProvidersPage'));
const ExternalProviderDetailPage = lazy(() => import('@pages/externalProviders/ExternalProviderDetailPage'));
const ExternalProviderFormPage = lazy(() => import('@pages/externalProviders/ExternalProviderFormPage'));

const ExternalProvidersListRoute = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('external-providers-page-title')}>
        <ExternalProvidersPage />
      </PageWrapper>
    </Suspense>
  );
};

const ExternalProviderDetailRoute = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('external-providers-detail-title')}>
        <ExternalProviderDetailPage />
      </PageWrapper>
    </Suspense>
  );
};

const ExternalProviderCreateRoute = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('external-providers-create-page-title')}>
        <ExternalProviderFormPage />
      </PageWrapper>
    </Suspense>
  );
};

const ExternalProviderEditRoute = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('external-providers-edit-page-title')}>
        <ExternalProviderFormPage />
      </PageWrapper>
    </Suspense>
  );
};

export default {
  ExternalProvidersListRoute,
  ExternalProviderDetailRoute,
  ExternalProviderCreateRoute,
  ExternalProviderEditRoute,
};
